import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'zone.js';

import { AppModule } from './app/app.module';

import { environment } from './environments/environment';

import * as Sentry from '@sentry/angular';

// The static host serves every deep link from a pre-generated folder (see post-build.js), so it
// 301-redirects /losteria_munchen_klenzestr to /losteria_munchen_klenzestr/index.html and keeps the
// query string. Angular's Location.normalize() drops /index.html with a `$`-anchored regex, so it
// only strips it when nothing follows: a link carrying UTM parameters keeps the extra segment, no
// route matches it and the router falls through to the '**' redirect back to the home page.
// Normalize the path here - before the router reads it - and keep query string and hash intact.
const stripIndexHtml = () => {
	const indexHtmlSuffix = '/index.html';
	const { pathname, search, hash } = window.location;
	if (!pathname.endsWith(indexHtmlSuffix)) {
		return;
	}
	const normalizedPath = pathname.slice(0, -indexHtmlSuffix.length) || '/';
	window.history.replaceState(window.history.state, '', normalizedPath + search + hash);
};
stripIndexHtml();

Sentry.init({
	dsn: 'https://377e5f5c89e250acfa8486859698e690@logs.smoothr.de/2',
	integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration({ maskAllInputs: true, stickySession: true, blockAllMedia: true, mutationLimit: 500, mutationBreadcrumbLimit: 100 })],
	tracesSampleRate: 0.1,
	profilesSampleRate: 0.1,
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
	environment: environment.production ? 'production' : 'development',
});

if (environment.production) {
	enableProdMode();
}
platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.catch(err => console.error(err));
